module.exports = __webpack_public_path__ + "static/media/light-search.e3a2ba8e.svg";